export default __webpack_public_path__ + "static/media/ico_emptyPage.c63adab6.svg";